import socketPromise from '../../../websocket';

let sendPeriodicEventIds = {};

let sendPeriodicEvent = function (event, chatId) {
    if (!sendPeriodicEventIds[chatId]) {
        event();
        sendPeriodicEventIds[chatId] = setInterval(event, 3000);
    }
    return sendPeriodicEventIds[chatId];
};

export function start(dispatch, { chatId }, state) {
    socketPromise.then((socket) => {
        sendPeriodicEvent(() => {
            socket.emit('typing', {
                channel: chatId + ':Chat',
                name: state.user.getIn([ 'data', 'name' ])
            });
        }, chatId);
    });
}

export function stop(dispatch, { chatId }) {
    clearInterval(sendPeriodicEventIds[chatId]);
    delete sendPeriodicEventIds[chatId];
}
